import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogDataCrudAlert {
  alertFields: string[];
}

@Component({
  selector: 'app-crud-alert',
  templateUrl: './crud-alert.component.html',
  styleUrls: ['./crud-alert.component.css']
})
export class CrudAlertComponent {
  constructor(public dialogRef: MatDialogRef<CrudAlertComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogDataCrudAlert) { }
}
